import clsx from "clsx";
import type { EquippedSlot, HeroClass } from "../types";
import { getItemIconPath, RARITY_COLOR, SLOT_SIDE } from "../utils/assets";
import { AdminAssetPath } from "./AdminAssetPath";

interface EquipmentPanelProps {
  equipped: EquippedSlot[];
  heroClass: HeroClass;
  onSlotClick: (slot: EquippedSlot) => void;
  className?: string;
}

export function EquipmentPanel({ equipped, heroClass, onSlotClick, className }: EquipmentPanelProps) {
  const left = equipped.filter((s) => SLOT_SIDE[s.slot] === "left");
  const right = equipped.filter((s) => SLOT_SIDE[s.slot] === "right");

  return (
    <div className={clsx("flex justify-between items-start gap-1 px-2 py-3 relative z-10", className)}>
      <div className="flex flex-col gap-2">
        {left.map((slot) => (
          <EquipSlotButton key={slot.slot} slot={slot} heroClass={heroClass} onClick={() => onSlotClick(slot)} />
        ))}
      </div>
      <div className="flex flex-col gap-2">
        {right.map((slot) => (
          <EquipSlotButton key={slot.slot} slot={slot} heroClass={heroClass} onClick={() => onSlotClick(slot)} />
        ))}
      </div>
    </div>
  );
}

function EquipSlotButton({
  slot,
  heroClass,
  onClick,
}: {
  slot: EquippedSlot;
  heroClass: HeroClass;
  onClick: () => void;
}) {
  const item = slot.item;
  const rarityClass = item ? (RARITY_COLOR[item.template.rarity] ?? RARITY_COLOR.JUNK) : "border-gray-700";
  const iconSrc = item
    ? getItemIconPath(
        item.template.hero_class ?? heroClass,
        item.template.slot,
        item.template.icon,
        item.template.item_level,
      )
    : null;

  return (
    <button
      onClick={onClick}
      className={clsx(
        "w-14 rounded-xl border-2 flex flex-col items-center justify-center transition-all py-0.5",
        item ? "bg-kingdom-mid/60 hover:border-kingdom-glow min-h-14" : "bg-kingdom-dark/80 border-dashed opacity-70 h-14",
        rarityClass,
      )}
      title={slot.slot_label}
    >
      {item && iconSrc ? (
        <>
          <img
            src={iconSrc}
            alt={item.template.name}
            className="w-10 h-10 object-contain"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
          <AdminAssetPath path={iconSrc} className="px-0.5 text-[7px] text-center max-w-full" />
        </>
      ) : (
        <span className="text-[8px] text-gray-500 text-center leading-tight px-1">{slot.slot_label}</span>
      )}
    </button>
  );
}
